export default "__VITE_ASSET__1e145e06__"